import { Component, OnInit, Inject } from '@angular/core';

import { UntypedFormControl } from '@angular/forms';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { SessionService } from '@tech-services/session.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogDataInterface } from '../modal-custom-date-report/dialog-data.interface';

@Component({
  selector: 'tech-modal-custom-date',
  templateUrl: './modal-custom-date.component.html',
  styleUrls: ['./modal-custom-date.component.scss'],
})
export class ModalCustomDateComponent implements OnInit {
  initialDateForm = new UntypedFormControl(new Date(this.data.initialDate));
  endDateForm = new UntypedFormControl(new Date(this.data.endDate));
  minDate: Date;
  maxDate: Date;
  initialDate: Date;
  endDate: Date;
  disableConfirm: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ModalCustomDateComponent>,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataInterface
  ) {
    this.initialDate = new Date(this.data.initialDate);
    this.endDate = new Date(this.data.endDate);
    this.minDate = new Date(this.data.minDate);
    this.maxDate = new Date(this.data.maxDate);
    this._adapter.setLocale(localStorage.getItem('Language'));
  }

  ngOnInit() {}

  addDate(type: string, event: MatDatepickerInputEvent<Date>) {
    switch (type) {
      case 'initialDate':
        this.initialDate = event.value;
        break;
      case 'endDate':
        if (event.value <= this.maxDate) {
          this.endDate = event.value;
          this.disableConfirm = false;
        } else {
          this.disableConfirm = true;
        }
        break;
      default:
        break;
    }
  }
}
